/* eslint-disable no-new */
import { FadeTransition } from 'vue2-transitions';
import BaseButton from '@/components/common/BaseButton.vue';

import { createNamespacedHelpers } from 'vuex';
const globalMapper = createNamespacedHelpers('global');

export default {
	name: 'Home',

	components: {
		FadeTransition,
		BaseButton,
	},

	data() {
		return {
			pageTitle: this.$t('welcome'),
		};
	},

	computed: {},

	methods: {
		...globalMapper.mapActions(['setIndicator']),

		onStartDetector() {
			this.setIndicator('showDetector');
			this.$router.push('/camera');
		},
	},
};
